<template>
  <v-row v-if="isVisible" class="align-center" fixed id="searchBar">
    <v-text-field
      ref="searchInput"
      @focus="userStartedTyping"
      @input="searchBarValueChanged"
      class="ml-4 mr-1 searchBarTextField"
      label="Search for a track"
      color="secondary"
      v-model="searchText"
    ></v-text-field>

    <v-tooltip :disabled="$vuetify.breakpoint.smAndDown" bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          x-small
          icon
          @click="clearSearch"
          class="mr-3 my-1 deactivateButtonBugFix"
          depressed
        >
          <v-icon v-on="on">mdi-close</v-icon>
        </v-btn>
      </template>
      <span>Clear search results</span>
    </v-tooltip>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'SearchBar',
  
  data() {
    return {
      searchText: '',
    };
  },
  
  computed: {
    ...mapGetters({
      isVisible: 'ui/isShowingSearchBar',
      isUserTyping: 'ui/isUserTyping',
    }),
  },
  
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.searchInput) {
        this.$refs.searchInput.focus();
      }
    });
  },

  watch: {
    isVisible(newValue) {
      if (!newValue) {
        this.searchText = '';
      }
    },
  },
  
  methods: {
    ...mapActions({
      updateSearchQuery: 'ui/updateSearchQuery',
      setUserTyping: 'ui/setUserTyping',
      toggleSearchBar: 'ui/toggleSearchBar',
      showSnackbar: 'ui/showSnackbar',
    }),
    
    userStartedTyping() {
      this.setUserTyping(true);
    },

    searchBarValueChanged() {
      this.updateSearchQuery(this.searchText);
    },
    
    clearSearch() {
      this.searchText = '';
      this.toggleSearchBar();
      this.setUserTyping(false);
    },
  }
};
</script>

<style scoped>
.searchBarTextField label {
  font-size: 14px !important;
}

.deactivateButtonBugFix:focus::before {
  opacity: 0 !important;
}
</style>